import BaseUseCase from "../base_use_case.js";
import GwtTokenStorage from "../../utils/gwt_token_storage.js";

class LogoutUseCase extends BaseUseCase {

  execute() {
    return this.httpClient({
      ...this.requestConfig(),
      method: "delete",
      url: `/api/v1/sessions/logout`
    }).then((result) => {
      GwtTokenStorage.clear();
      return result;
    });
  }
}

const instance = new LogoutUseCase();
export default instance;